<script setup>
import CharacterEnlarge from '../kijk_live_qmusic_nl_default/text_animations/CharacterEnlarge.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const counterValue = computed(() =>
  props.item.properties?.staticOverride ? props.item.properties?.counterFixedValue?.toLocaleString('nl-NL') ?? 0 : props.item.enrichment?.counterDynamicValue?.toLocaleString('nl-NL') ?? 0
)

const timelineGenericCounter = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'GenericCounter' }).add(timelineGenericCounter)
})
</script>

<template>
  <div
    :style="{
      left: item.properties.position.xCenter + 'px',
      top: item.properties.position.yTop + 'px',
      fontSize: item.properties.position.fontSize + 'px',
    }"
    :class="`absolute -translate-x-1/2 tracking-[-14px] font-cervo text-white font-bold leading-none text-center drop-shadow-[0.4rem_0.4rem_0px_rgb(70_70_70)]`"
  >
    <CharacterEnlarge :text="`${counterValue}`" class="flex-nowrap" @timeline="timelineGenericCounter = $event" />
  </div>
</template>
